var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-list',{staticClass:"pa-0",attrs:{"dense":!_vm.AppIsSmall,"flat":"","tile":""}},[_vm._l((_vm.items),function(item,i){return [_c('app-list-item',{key:("list-item-" + (i.toString())),attrs:{"item":item}})]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }